import { getColor } from "../shared.js";
import { Title } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/titles/BaseTitle.tsx
const BaseTitle = ({ children, order, color = "gray", size = "2rem", ta, "data-testid": testId }) => /* @__PURE__ */ jsx(Title, {
	order,
	size,
	ta,
	style: {
		color: getColor(color, true),
		textWrap: "pretty"
	},
	"data-testid": testId,
	children
});

//#endregion
export { BaseTitle };